/* eslint-disable */
/* global google */
import React, { Component } from 'react';
import { compose, withHandlers } from 'recompose';
import moment from 'moment';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    Polyline,
    InfoWindow,
    DirectionsRenderer,
} from 'react-google-maps';
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import * as utils from '../../../utils';
import * as api from '../../../epics/api';

function customIconColor(opts) {
    return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: '#34495e',
        fillOpacity: 1,
        strokeColor: '#000',
        strokeWeight: 1,
        scale: 1,
        ...opts,
    };
}

function pinSymbol(color) {
    return {
        path: 'M0 0 S0 -8 -4 -8 H-4 C-8 -8 -8 -8 -8 -12 V-12 C-8 -16 -8 -16 -4 -16 H4 C8 -16 8 -16 8 -12 V-12 C8 -8 8 -8 4 -8 H4 S0 -8 0 0',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#FFF',
        strokeWeight: 2,
        scale: 2,
    };
}

function hslToRgb(h, s, l) {
    let r;
    let g;
    let b;

    if (s == 0) {
        r = g = b = l; // achromatic
    } else {
        const hue2rgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return `#${Math.round(r * 255).toString(16)}${Math.round(g * 255).toString(
        16,
    )}${Math.round(b * 255).toString(16)}`;
}

const getIcon = (job, props) => {
    let icon;
    let color;
    const etaVsStart = props.countDownTimer(
        job.start_datetime,
        job.booking.eta,
    );

    // TODO Fix crap copied from etacell
    if (etaVsStart) {
        if (etaVsStart[0] == 'minutes') {
            if (etaVsStart[2] == '-' && etaVsStart[1] > 15) {
                color = 'green';
            } else if (etaVsStart[2] == '-') {
                color = 'yellow';
            } else {
                color = 'red';
            }
        } else if (etaVsStart[2] == '-') {
            color = 'green';
        } else {
            color = 'red';
        }
    }

    if (job.service == 'hospitality') {
        icon = `/static/svg/pin-scooter-${color}.svg`;
    } else if (job.vehicle_type == 1) {
        icon = `/static/svg/pin-van-${color}.svg`;
    } else if (job.vehicle_type == 2) {
        icon = `/static/svg/pin-car-${color}.svg`;
    } else if (job.vehicle_type == 3) {
        icon = `/static/svg/pin-scooter-${color}.svg`;
    } else {
        icon = `/static/svg/pin-scooter-${color}.svg`;
    }

    if (job.service_role == 'waiter') {
        icon = `/static/images/pin-scooter-${color}.svg`;
    }

    return {
        url: icon,
    };
};

const getLastUpdatedPosition = (job, props) => {
    const etarefresh = props.countDownTimer(
        new Date(),
        job.booking.eta_updated,
    );
    const refresh = etarefresh
        ? `${etarefresh[1]} ${etarefresh[0]} ago`
        : 'N/A';
    return refresh;
};

const MapWithAMarker = compose(withGoogleMap)(props => {
    let markerRender;
    let destinationMarker;
    let polylineRender;

    if (!props.showDirections && props.data) {
        markerRender = props.data.map(job => (
            <Marker
                position={{
                    lat: job.booking.latest_position.latitude,
                    lng: job.booking.latest_position.longitude,
                }}
                onClick={() => props.onMarkerClick(job)}
                onDblClick={() => props.onMarkerOnDblClick(job)}
                key={job.booking.id}
                icon={getIcon(job, props)}
                style={{ height: '5xpx', width: '5px' }}
                className="marker"
                labelInBackground={false}
            >
                {job.showInfo && (
                    <InfoWindow onCloseClick={() => props.onMarkerClose(job)}>
                        <div>
                            <p>{job.booking.freelancer_detail.full_name}</p>
                            <p>
                                Last update {getLastUpdatedPosition(job, props)}
                            </p>
                        </div>
                    </InfoWindow>
                )}
            </Marker>
        ));
    } else {
        const totalPositions = props.freelancerPositions.length;
        if (props.freelancerPositions.length != 0) {
            const mintime = moment(
                props.freelancerPositions.slice(0)[0].created,
            ).valueOf();
            const maxtime = moment(
                props.freelancerPositions.slice(-1)[0].created,
            ).valueOf();
            const totalRage = maxtime - mintime || mintime;
            const clockin = props.job.booking
                ? props.job.booking.clock_in
                : null;

            if (
                (props.job.booking.latest_position && clockin) ||
                moment(props.job.start_datetime) < moment()
            ) {
                markerRender = props.freelancerPositions.map(
                    (position, index) => (
                        <MarkerWithLabel
                            position={{
                                lat: position.latitude,
                                lng: position.longitude,
                            }}
                            key={position.id}
                            labelAnchor={new google.maps.Point(14, 32)}
                            icon={pinSymbol(
                                hslToRgb(
                                    0.28 -
                                        (0.27 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                    0.48 +
                                        (0.47 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                    0.49 +
                                        (0.16 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                ),
                            )}
                        >
                            <span
                                style={{
                                    fontFamily: 'Lucida Grande',
                                    fontWeight: '800',
                                    color: 'white',
                                    fontSize: '10px',
                                    letterSpacing: '-0.5px',
                                    textAlign: 'center',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {moment(position.created).format('HH:mm')}
                            </span>
                        </MarkerWithLabel>
                    ),
                );

                destinationMarker = (
                    <Marker
                        position={{
                            lat: props.job.latitude,
                            lng: props.job.longitude,
                        }}
                        key={props.job.id}
                        style={{ height: '5xpx', width: '5px' }}
                        className="marker"
                        icon={customIconColor({
                            fillColor: '#327FBC',
                        })}
                    />
                );

                polylineRender = (
                    <Polyline
                        options={{
                            strokeColor: '#277DBC',
                            strokeOpacity: 0.7,
                            strokeWeight: 3,
                        }}
                        path={props.freelancerPositions.map(
                            (position, index) => ({
                                lng: position.longitude,
                                lat: position.latitude,
                            }),
                        )}
                    />
                );
            } else {
                markerRender = props.freelancerPositions.map(
                    (position, index) => (
                        <Marker
                            position={{
                                lat: position.latitude,
                                lng: position.longitude,
                            }}
                            key={position.id}
                            onClick={() => props.onMarkerClick(position, true)}
                            style={{ height: '5xpx', width: '5px' }}
                            className="marker"
                            icon={customIconColor({
                                fillColor: hslToRgb(
                                    0.28 -
                                        (0.27 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                    0.48 +
                                        (0.47 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                    0.49 +
                                        (0.16 *
                                            (moment(
                                                position.created,
                                            ).valueOf() -
                                                mintime)) /
                                            totalRage,
                                ),
                            })}
                        >
                            {position.showInfo && (
                                <InfoWindow
                                    onCloseClick={() =>
                                        props.onMarkerClose(position, true)
                                    }
                                >
                                    <div>
                                        <p>
                                            Received at{' '}
                                            {moment(position.created).format(
                                                'HH:mm',
                                            )}
                                        </p>
                                    </div>
                                </InfoWindow>
                            )}
                        </Marker>
                    ),
                );
            }
        }
    }

    return (
        <GoogleMap
            defaultZoom={11}
            defaultCenter={{ lat: props.center.lat, lng: props.center.lng }}
            ref={props.onMapMounted}
            defaultOptions={{ styles: props.mapStyle }}
        >
            {markerRender}
            {destinationMarker}
            {polylineRender}

            {props.directions && (
                <DirectionsRenderer
                    directions={props.directions}
                    options={{ suppressInfoWindows: true }}
                />
            )}
        </GoogleMap>
    );
});

export default class LocationMapContainer extends Component {
    constructor(props) {
        super(props);

        this.handleMarkerOnDblClick = this.handleMarkerOnDblClick.bind(this);
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleMarkerClose = this.handleMarkerClose.bind(this);
        this.onMapMounted = this.onMapMounted.bind(this);

        this.state = {
            data: this.props.data,
            job: this.props.job,
            freelancerPositions: [],
            directions: null,
            directionsService: null,
            center: {
                lat: 51.509865,
                lng: -0.118092,
            },
            refs: {
                map: undefined,
            },
            mapStyles: [
                {
                    featureType: 'all',
                    stylers: [{ saturation: '-75' }],
                },
                {
                    featureType: 'poi',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'administrative.locality',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'water',
                    stylers: [
                        { hue: '0' },
                        { saturation: '40' },
                        { lightness: '-10' },
                    ],
                },
            ],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.state.data) {
            this.setState({ data: nextProps.data });
        }
        if (nextProps.job != this.state.job) {
            this.setState({ job: nextProps.job });
        }
    }

    onMapMounted = ref => {
        this.directionsService = new google.maps.DirectionsService();
        this.setState({
            refs: {
                map: ref,
            },
            directionsService: new google.maps.DirectionsService(),
        });

        if (this.props.showDirections && this.state.job) {
            this.getFreelancerPostions(
                this.state.job.booking.freelancer_detail.id,
                this.state.job.booking.id,
            );

            const clockin = this.state.job.booking.booking
                ? this.state.job.booking.booking.clock_in
                : null;

            if (
                this.state.job.booking.latest_position &&
                !this.state.job.booking.first_seen &&
                !clockin
            ) {
                let travelMode;

                if (this.state.job.service == 'driver') {
                    travelMode = google.maps.TravelMode.DRIVING;
                } else {
                    travelMode = google.maps.TravelMode.TRANSIT;
                }

                this.directionsService.route(
                    {
                        origin: new google.maps.LatLng(
                            this.state.job.booking.latest_position.latitude,
                            this.state.job.booking.latest_position.longitude,
                        ),
                        destination: new google.maps.LatLng(
                            this.state.job.latitude,
                            this.state.job.longitude,
                        ),
                        travelMode,
                    },
                    (result, status) => {
                        if (status === google.maps.DirectionsStatus.OK) {
                            this.setState({
                                directions: result,
                            });
                        }
                    },
                );
            }
        }
    };

    getFreelancerPostions(freelancerId, booking_id) {
        const self = this;
        const response = api.executeHttpRequest(
            `freelancers/${freelancerId}/positions/?&booking=${booking_id}&paginate_by=1000`,
            'get',
            {},
        );
        response.then(res => {
            const positions = res.data.content.filter(
                position => position.latitude && position.longitude,
            );
            positions.forEach(obj => {
                obj.showInfo = false;
            });

            self.setState({
                freelancerPositions: positions,
            });
        });
        response.catch(err => {
            self.props.notification.error(
                'Error',
                'Thier is no GPS data available for this freelancer',
            );
        });
    }

    handleMarkerOnDblClick(targetMarker) {
        this.props.toggleShowFreelancerTable(targetMarker);
    }

    handleMarkerClick(targetMarker, isPosition = false) {
        if (isPosition) {
            this.setState({
                freelancerPositions: this.state.freelancerPositions.map(
                    position => {
                        if (position.id === targetMarker.id) {
                            return {
                                ...position,
                                showInfo: true,
                            };
                        }
                        return position;
                    },
                ),
            });
        } else {
            this.setState({
                data: this.state.data.map(job => {
                    if (job.booking.id === targetMarker.booking.id) {
                        return {
                            ...job,
                            showInfo: true,
                        };
                    }
                    return job;
                }),
            });
        }
    }

    handleMarkerClose(targetMarker, isPosition = false) {
        if (isPosition) {
            this.setState({
                freelancerPositions: this.state.freelancerPositions.map(
                    position => {
                        if (position.id === targetMarker.id) {
                            return {
                                ...position,
                                showInfo: false,
                            };
                        }
                        return position;
                    },
                ),
            });
        } else {
            this.setState({
                data: this.state.data.map(job => {
                    if (job.booking.id === targetMarker.booking.id) {
                        return {
                            ...job,
                            showInfo: false,
                        };
                    }
                    return job;
                }),
            });
        }
    }

    render() {
        const isAgent = this.props.isAgent;
        const containerHeight = isAgent
            ? 'calc(100% - 134px - 56px)'
            : 'calc(100% - 134px)';
        return (
            <MapWithAMarker
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDqHBEWoYWwCSk_GUKhIcg06jbpgaUZRe4&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: '100%' }} />}
                containerElement={<div style={{ height: containerHeight }} />}
                mapElement={<div style={{ height: '100%' }} />}
                onMarkerOnDblClick={this.handleMarkerOnDblClick}
                onMarkerClick={this.handleMarkerClick}
                onMarkerClose={this.handleMarkerClose}
                onMapMounted={this.onMapMounted}
                markers={this.state.markers}
                center={this.state.center}
                directions={this.state.directions}
                freelancerPositions={this.state.freelancerPositions}
                showDirections={this.props.showDirections}
                job={this.state.job}
                data={this.state.data}
                countDownTimer={this.props.countDownTimer}
                mapStyle={this.state.mapStyles}
            />
        );
    }
}
